import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import TopHeader from "../template/TopHeader";
import { connect, useDispatch } from "react-redux";
import toast from '../shared/Toast';
import { compressImages, isHeicFile } from '../shared/imageCompress';
import { productAction } from "../../_actions/product.action";
import { productService } from "../../_services/product.service";
import InlinePickerSelect from '../shared/InlinePickerSelect';
import useWindowSize from "../new-service/useWindowSize";
import CancelSaveBtn from "../new-service/add-edit-service/CancelSaveBtn";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Select from 'react-select';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove, sortableKeyboardCoordinates, useSortable, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import "../new-service/newservice.css";
import "./product.css";

function AddProduct(props) {
  // Product Details
  const [productName, setProductName] = useState("");
  const [productCategory, setProductCategory] = useState(null);
  const [productBrand, setProductBrand] = useState(null);
  const [description, setDescription] = useState("");
  
  // Product Images
  const [productImages, setProductImages] = useState([]);
  const fileInputRef = useRef(null);
  
  // Pricing
  const [retailPrice, setRetailPrice] = useState("");
  const [stockPrice, setStockPrice] = useState("");
  const [commissionEnable, setCommissionEnable] = useState("no");
  
  // Stock
  const [barcode, setBarcode] = useState("");
  const [sku, setSku] = useState("");
  const [trackStock, setTrackStock] = useState("yes");
  const [sellOnline, setSellOnline] = useState("no");
  
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [errors, setErrors] = useState({});
  
  // Initialize currency symbol from user profile
  useEffect(() => {
    if (props?.user?.userInfo?.hairdresser?.currencySymbol) {
      setCurrencySymbol(props.user.userInfo.hairdresser.currencySymbol);
    }
  }, [props?.user?.userInfo?.hairdresser?.currencySymbol]);
  const [activeTab, setActiveTab] = useState("details");
  
  const dispatch = useDispatch();
  const history = useHistory();
  const { width } = useWindowSize();

  // State for category and brand options
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showNewCategory, setShowNewCategory] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [showNewBrand, setShowNewBrand] = useState(false);
  const [newBrandName, setNewBrandName] = useState('');

  // Fetch categories and brands on component mount
  useEffect(() => {
    setIsLoading(true);
    
    // Fetch categories
    dispatch(productAction.listProductCategories())
      .then((response) => {
        console.log("Categories response:", response);
        const categories = response?.data?.responseData?.categories || [];
        const formattedCategories = categories.map(category => ({
          value: category.categoryId,
          label: category.categoryName
        }));
        setCategoryOptions(formattedCategories);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        toast.error("Failed to load product categories");
      });
    
    // Fetch brands
    dispatch(productAction.listProductBrands())
      .then((response) => {
        console.log("Brands response:", response);
        const brands = response?.data?.responseData?.brands || [];
        const formattedBrands = brands.map(brand => ({
          value: brand.brandId,
          label: brand.brandName
        }));
        setBrandOptions(formattedBrands);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching brands:", err);
        toast.error("Failed to load product brands");
        setIsLoading(false);
      });
  }, [dispatch]);
  
  const commissionOptions = [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" }
  ];
  
  const trackStockOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" }
  ];

  const sellOnlineOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" }
  ];

  // Custom styles for Select component
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? '1px solid #007EA0' : '1px solid #e0e0e0',
      borderRadius: '10px',
      minHeight: '44px',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 126, 160, 0.08)' : 'none',
      background: '#fff',
      cursor: 'pointer',
      transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
      '&:hover': {
        borderColor: state.isFocused ? '#007EA0' : '#ccc',
      },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#999',
      padding: '8px 10px',
      '&:hover': { color: '#666' },
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#333',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#aaa',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '12px',
      border: '1px solid #e8e8e8',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04)',
      overflow: 'hidden',
      zIndex: 20,
      marginTop: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '4px',
      maxHeight: '240px',
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '14px',
      padding: '10px 12px',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'background 0.1s ease',
      backgroundColor: state.isSelected ? '#29282D' : state.isFocused ? '#f0f0f0' : '#fff',
      color: state.isSelected ? '#fff' : '#333',
      '&:active': {
        backgroundColor: state.isSelected ? '#29282D' : '#e8e8e8',
      },
    }),
  };

  // Validation function
  const validateFields = (name, value) => {
    let error = '';
    switch (name) {
      case 'productName':
        if (!value) {
          error = "Product Name is required.";
        }
        break;
      case 'productCategory':
        if (!value) {
          error = "Product Category is required.";
        }
        break;
      case 'retailPrice':
        if (!value) {
          error = "Retail Price is required.";
        } else if (isNaN(value)) {
          error = "Retail Price must be a number.";
        }
        break;
      case 'stockPrice':
        if (!value) {
          error = "Stock Price is required.";
        } else if (isNaN(value)) {
          error = "Stock Price must be a number.";
        } else if (parseFloat(stockPrice) > parseFloat(retailPrice)) {
          error = "Stock Price cannot be greater than Retail Price.";
        }
        break;
      default:
        break;
    }
    return error;
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case 'productName':
        setProductName(value);
        break;
      case 'retailPrice':
        // Allow empty string, numbers, and decimal points
        if (value === '' || /^\d*\.?\d*$/.test(value)) {
          setRetailPrice(value);
        }
        break;
      case 'stockPrice':
        // Allow empty string, numbers, and decimal points
        if (value === '' || /^\d*\.?\d*$/.test(value)) {
          setStockPrice(value);
        }
        break;
      case 'description':
        setDescription(value);
        break;
      case 'barcode':
        setBarcode(value);
        break;
      case 'sku':
        setSku(value);
        break;
      default:
        break;
    }

    setErrors(prev => ({
      ...prev,
      [name]: validateFields(name, value)
    }));
  };

  // Handle dropdown changes
  const handleCategoryChange = (selected) => {
    if (selected?.value === '__create_new__') {
      setShowNewCategory(true);
      return;
    }
    setProductCategory(selected);
    setShowNewCategory(false);
    setErrors(prev => ({
      ...prev,
      productCategory: validateFields('productCategory', selected)
    }));
  };

  const handleCreateCategory = () => {
    const name = newCategoryName.trim();
    if (!name) return;
    productService.addProductCategory({ categoryName: name })
      .then(response => {
        const rd = response?.data?.responseData || response?.data?.data || response?.data || {};
        const newCat = rd.category || rd.result || rd;
        const catId = newCat.categoryId || newCat._id || newCat.id;
        if (catId) {
          const option = { value: catId, label: name };
          setCategoryOptions(prev => [...prev, option]);
          setProductCategory(option);
          setShowNewCategory(false);
          setNewCategoryName('');
          setErrors(prev => ({ ...prev, productCategory: '' }));
          toast.success('Category created');
        } else {
          // Category created but ID not in response - reload categories
          dispatch(productAction.listProductCategories())
            .then(res => {
              const categories = res?.data?.responseData?.categories || [];
              const formatted = categories.map(c => ({ value: c.categoryId, label: c.categoryName }));
              setCategoryOptions(formatted);
              const match = formatted.find(c => c.label === name);
              if (match) setProductCategory(match);
            });
          setShowNewCategory(false);
          setNewCategoryName('');
          toast.success('Category created');
        }
      })
      .catch(() => toast.error('Failed to create category'));
  };

  const handleBrandChange = (selected) => {
    if (selected?.value === '__create_new__') {
      setShowNewBrand(true);
      return;
    }
    setProductBrand(selected);
    setShowNewBrand(false);
  };

  const handleCreateBrand = () => {
    const name = newBrandName.trim();
    if (!name) return;
    productService.addProductBrand({ brandName: name })
      .then(response => {
        const rd = response?.data?.responseData || response?.data?.data || response?.data || {};
        const newBr = rd.brand || rd.result || rd;
        const brId = newBr.brandId || newBr._id || newBr.id;
        if (brId) {
          const option = { value: brId, label: name };
          setBrandOptions(prev => [...prev, option]);
          setProductBrand(option);
          setShowNewBrand(false);
          setNewBrandName('');
          toast.success('Brand created');
        } else {
          dispatch(productAction.listProductBrands())
            .then(res => {
              const brands = res?.data?.responseData?.brands || [];
              const formatted = brands.map(b => ({ value: b.brandId || b._id, label: b.brandName }));
              setBrandOptions(formatted);
              const match = formatted.find(b => b.label === name);
              if (match) setProductBrand(match);
            });
          setShowNewBrand(false);
          setNewBrandName('');
          toast.success('Brand created');
        }
      })
      .catch(() => toast.error('Failed to create brand'));
  };

  const handleCommissionChange = (selected) => {
    setCommissionEnable(selected.value);
  };

  const handleTrackStockChange = (selected) => {
    setTrackStock(selected.value);
  };

  const handleSellOnlineChange = (selected) => {
    setSellOnline(selected.value);
  };

  // Handle image upload
  const handleImageUpload = async (e) => {
   try {
    const files = Array.from(e.target.files);

    // Check file type and size (large source photos are allowed — they're
    // optimised below before upload).
    const validFiles = files.filter(file => {
      const isValidType = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'].includes(file.type) || isHeicFile(file);
      const isValidSize = file.size <= 25 * 1024 * 1024;

      if (!isValidType) {
        toast.error(`${file.name} is not a supported image format.`);
      }

      if (!isValidSize) {
        toast.error(`${file.name} is too large (max 25MB).`);
      }

      return isValidType && isValidSize;
    });

    if (validFiles.length === 0) return;

    // Downscale/re-encode big images so they fit under the upload size limit.
    let processed = validFiles;
    try { processed = await compressImages(validFiles); } catch (err) { processed = validFiles; }
    // A HEIC that survived compression means this browser can't decode iPhone
    // photos (WebKit can; Chrome/Windows can't). Say so instead of uploading
    // a file the storefront can never display.
    processed = processed.filter((f) => {
      if (isHeicFile(f)) {
        toast.error(`${f.name} is an iPhone photo in HEIC format, which browsers can't read. Pick it from your Photo Library instead (it converts automatically), or use a JPG/PNG copy.`);
        return false;
      }
      return true;
    });
    if (processed.length === 0) return;

    // Create preview URLs for valid files
    const newImages = processed.map((file, idx) => ({
      id: `new-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      file,
      preview: URL.createObjectURL(file),
      order: productImages.length + idx // Set initial order based on current length
    }));

    setProductImages(prev => [...prev, ...newImages]);
   } catch (err) {
    // iOS Safari can invalidate picked files or fail mid-processing; say so
    // instead of doing nothing.
    console.error('Image add failed', err);
    toast.error('Could not read that photo. Please try again.');
   }
  };

  // Handle image removal
  const handleRemoveImage = (index) => {
    setProductImages(prev => {
      const newImages = [...prev];
      // Revoke the object URL to avoid memory leaks
      URL.revokeObjectURL(newImages[index].preview);
      newImages.splice(index, 1);
      return newImages;
    });
  };

  // Handle barcode scanner
  const handleScanBarcode = () => {
    // This would be implemented with a barcode scanning library
    toast.info("Barcode scanner functionality would be implemented here");
  };

  // Handle save button click
  const handleSave = () => {
    setErrors({});
    
    const newErrors = {
      productName: validateFields('productName', productName),
      productCategory: validateFields('productCategory', productCategory),
      retailPrice: validateFields('retailPrice', retailPrice),
      stockPrice: validateFields('stockPrice', stockPrice)
    };
    
    const filteredErrors = Object.fromEntries(Object.entries(newErrors).filter(([_, v]) => v));
    setErrors(filteredErrors);

    if (Object.keys(filteredErrors).length > 0) {
      // Show which tab has errors
      if (filteredErrors.productName || filteredErrors.productCategory) {
        setActiveTab("details");
      } else if (filteredErrors.retailPrice || filteredErrors.stockPrice) {
        setActiveTab("pricing");
      }
      return;
    }

    if (parseFloat(stockPrice) > parseFloat(retailPrice)) {
      toast.error("Stock price cannot be greater than retail price.");
      setActiveTab("pricing");
      return;
    }
  
    // Create a FormData object to handle file uploads
    const formData = new FormData();
    
    // Add product details to FormData
    formData.append('productName', productName);
    formData.append('retailPrice', parseFloat(retailPrice));
    formData.append('stockPrice', parseFloat(stockPrice));
    formData.append('commissionEnable', commissionEnable === "no" ? 0 : 1);
    formData.append('description', description || "");
    
    if (productCategory) {
      formData.append('categoryId', productCategory.value);
    }
    
    if (productBrand) {
      formData.append('brandId', productBrand.value);
    }
    
    formData.append('barcode', barcode || "");
    formData.append('sku', sku || "");
    formData.append('trackStock', trackStock === "yes" ? 1 : 0);
    formData.append('sellOnline', sellOnline === "yes" ? 1 : 0);
    
    // Add images to FormData with order information
    if (productImages.length > 0) {
      // First, append the image order information as a JSON string
      // Make sure to use the order property that was set during drag and drop
      formData.append('imageOrder', JSON.stringify(productImages.map((img, index) => ({
        id: img.id,
        order: img.order !== undefined ? img.order : index
      }))));
      
      // Log the image order for debugging
      console.log("Image order being sent:", JSON.parse(formData.get('imageOrder')));
      
      // Then append the actual image files
      productImages.forEach((image) => {
        formData.append('images', image.file);
      });
    }
    
    console.log("Sending product data with images");
    
    // Send the FormData to the API
    dispatch(productAction.addProduct(formData))
      .then((response) => {
        console.log('Add response', response);
        
        // Reset form
        setProductName("");
        setProductCategory(null);
        setProductBrand(null);
        setDescription("");
        setProductImages([]);
        setRetailPrice("");
        setStockPrice("");
        setCommissionEnable("no");
        setBarcode("");
        setSku("");
        setTrackStock("yes");
        
        toast.success("Product Added Successfully");
        history.push("/product");
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to add product");
      });
  };

  // Render product details section
  const renderProductDetails = () => (
    <div className="cm_box_view mt-4 _left_right_spac">
      <h4 className="mt-2">Product Details</h4>
      <div className="filters-popup pt-3">
        <div className="row">
          <div className="col-md-12">
            <div className="filter-group">
              <label>Product Name</label>
              <input
                type="text"
                name="productName"
                placeholder="e.g. Shampoo"
                className="form-controls"
                value={productName}
                onChange={handleChange}
              />
              {errors.productName && <span className="cm_error_msg">{errors.productName}</span>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="filter-group">
              <InlinePickerSelect
                label="Product Category"
                options={categoryOptions}
                value={productCategory}
                onChange={(selected) => {
                  setProductCategory(selected);
                  setErrors(prev => ({ ...prev, productCategory: validateFields('productCategory', selected) }));
                }}
                onCreateNew={async (name) => {
                  try {
                    const response = await productService.addProductCategory({ categoryName: name });
                    const rd = response?.data?.responseData || response?.data?.data || response?.data || {};
                    const newCat = rd.category || rd.result || rd;
                    const catId = newCat.categoryId || newCat._id || newCat.id;
                    if (catId) {
                      const option = { value: catId, label: name };
                      setCategoryOptions(prev => [...prev, option]);
                      setProductCategory(option);
                      setErrors(prev => ({ ...prev, productCategory: '' }));
                      toast.success('Category created');
                    } else {
                      const res = await dispatch(productAction.listProductCategories());
                      const cats = res?.data?.responseData?.categories || [];
                      const formatted = cats.map(c => ({ value: c.categoryId, label: c.categoryName }));
                      setCategoryOptions(formatted);
                      const match = formatted.find(c => c.label === name);
                      if (match) { setProductCategory(match); setErrors(prev => ({ ...prev, productCategory: '' })); }
                      toast.success('Category created');
                    }
                  } catch { toast.error('Failed to create category'); throw new Error(); }
                }}
                placeholder="Choose a Category"
                createLabel="Create new category"
                searchPlaceholder="Search categories..."
                error={errors.productCategory}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="filter-group">
              <InlinePickerSelect
                label="Product Brand"
                options={brandOptions}
                value={productBrand}
                onChange={(selected) => setProductBrand(selected)}
                onCreateNew={async (name) => {
                  try {
                    const response = await productService.addProductBrand({ brandName: name });
                    const rd = response?.data?.responseData || response?.data?.data || response?.data || {};
                    const newBr = rd.brand || rd.result || rd;
                    const brId = newBr.brandId || newBr._id || newBr.id;
                    if (brId) {
                      const option = { value: brId, label: name };
                      setBrandOptions(prev => [...prev, option]);
                      setProductBrand(option);
                      toast.success('Brand created');
                    } else {
                      const res = await dispatch(productAction.listProductBrands());
                      const brands = res?.data?.responseData?.brands || [];
                      const formatted = brands.map(b => ({ value: b.brandId || b._id, label: b.brandName }));
                      setBrandOptions(formatted);
                      const match = formatted.find(b => b.label === name);
                      if (match) setProductBrand(match);
                      toast.success('Brand created');
                    }
                  } catch { toast.error('Failed to create brand'); throw new Error(); }
                }}
                placeholder="Choose a Brand"
                createLabel="Create new brand"
                searchPlaceholder="Search brands..."
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="filter-group">
              <label>Product Description</label>
              <textarea
                name="description"
                placeholder="Add a description to give prospective clients more information about your product."
                value={description}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Sortable Image Item Component
  const SortableImageItem = ({ image, index }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
    } = useSortable({ id: image.id || `new-${index}` });
    
    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };
    
    return (
      <div
        ref={setNodeRef}
        style={style}
        className="col-md-3 col-sm-6 mb-3"
      >
        <div className="image-preview-item">
          <img src={image.preview} alt={`Preview ${index}`} />
          <button
            className="remove-image-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveImage(index);
            }}
          >
            ×
          </button>
          <div
            className="drag-handle"
            {...attributes}
            {...listeners}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 9H16M8 15H16" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
        </div>
      </div>
    );
  };

  // Setup DnD sensors
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // Handle DnD end
  const handleDragEnd = (event) => {
    const { active, over } = event;
    
    if (active.id !== over.id) {
      setProductImages((items) => {
        const oldIndex = items.findIndex(item => (item.id || `new-${items.indexOf(item)}`) === active.id);
        const newIndex = items.findIndex(item => (item.id || `new-${items.indexOf(item)}`) === over.id);
        
        // Create a new array with the items in the new order
        const newItems = arrayMove([...items], oldIndex, newIndex);
        
        // Update displayOrder values to match the new order
        newItems.forEach((item, index) => {
          item.order = index;
        });
        
        console.log("New image order:", newItems.map((item, idx) => ({
          id: item.id,
          order: idx
        })));
        
        return newItems;
      });
    }
  };

  // Render product images section
  const renderProductImages = () => (
    <div className="cm_box_view mt-4 _left_right_spac">
      <h4 className="mt-2">Product Images</h4>
      <div className="filters-popup pt-3">
        <div className="image-upload-container">
          <div
            className="image-upload-area"
            onClick={() => fileInputRef.current.click()}
          >
            <div className="upload-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V8M12 8L9 11M12 8L15 11" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#666" strokeWidth="2"/>
              </svg>
            </div>
            <p>Drag and drop image files here, or click to browse</p>
            <p className="text-muted">JPG, PNG or WEBP. Large photos are optimised automatically.</p>
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept="image/jpeg, image/png, image/webp"
            multiple
            onClick={(e) => {
                                    // The invisible input covers its wrapper tile, whose own
                                    // onClick calls input.click() — without stopPropagation the
                                    // bubble re-clicks the input and WebKit (Safari/iOS) opens a
                                    // SECOND file dialog, wiping the first pick. Chrome suppresses
                                    // the re-entrant dialog, which is why it only broke on Safari.
                                    e.stopPropagation();
                                    e.target.value = '';
                                }}
                onChange={handleImageUpload}
          />
        </div>
        
        {productImages.length > 0 && (
          <div className="image-preview-container mt-4">
            <div className="d-flex align-items-center mb-2">
              <h5 className="mb-0 mr-2">Images</h5>
              <small className="text-muted">(Drag to reorder)</small>
            </div>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <div className="row">
                <SortableContext
                  items={productImages.map((img, idx) => ({ id: img.id || `new-${idx}` }))}
                  strategy={horizontalListSortingStrategy}
                >
                  {productImages.map((image, index) => (
                    <SortableImageItem
                      key={image.id || `new-${index}`}
                      image={image}
                      index={index}
                    />
                  ))}
                </SortableContext>
              </div>
            </DndContext>
          </div>
        )}
      </div>
    </div>
  );

  // Render pricing section
  const renderPricing = () => (
    <div className="cm_box_view mt-4 _left_right_spac">
      <h4 className="mt-2">Pricing</h4>
      <div className="filters-popup pt-3">
        <div className="row">
          <div className="col-md-6">
            <div className="filter-group">
              <label>Retail Price <span className="text-muted">(this is the price the item is sold at)</span></label>
              <div className="price-input-container">
                <div className="currency-symbol">{currencySymbol}</div>
                <input
                  type="text"
                  name="retailPrice"
                  placeholder="0.00"
                  className="form-controls price-input"
                  value={retailPrice}
                  onChange={handleChange}
                  onBlur={() => {
                    if (retailPrice && !isNaN(parseFloat(retailPrice))) {
                      setRetailPrice(parseFloat(retailPrice).toFixed(2));
                    }
                  }}
                />
              </div>
              {errors.retailPrice && <span className="cm_error_msg">{errors.retailPrice}</span>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="filter-group">
              <label>Stock Price <span className="text-muted">(this is the cost for the item to the business)</span></label>
              <div className="price-input-container">
                <div className="currency-symbol">{currencySymbol}</div>
                <input
                  type="text"
                  name="stockPrice"
                  placeholder="0.00"
                  className="form-controls price-input"
                  value={stockPrice}
                  onChange={handleChange}
                  onBlur={() => {
                    if (stockPrice && !isNaN(parseFloat(stockPrice))) {
                      setStockPrice(parseFloat(stockPrice).toFixed(2));
                    }
                  }}
                />
              </div>
              {errors.stockPrice && <span className="cm_error_msg">{errors.stockPrice}</span>}
              {parseFloat(stockPrice) > parseFloat(retailPrice) && 
                <span className="cm_error_msg">Stock price cannot be greater than retail price.</span>
              }
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="filter-group">
              <label>Commission Enabled</label>
              <Select
                options={commissionOptions}
                value={commissionOptions.find(option => option.value === commissionEnable)}
                classNamePrefix="my-select"
                onChange={handleCommissionChange}
                styles={customStyles}
                placeholder="Choose Yes/No"
                isSearchable={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Render stock section
  const renderStock = () => (
    <div className="cm_box_view mt-4 _left_right_spac">
      <h4 className="mt-2">Stock</h4>
      <div className="filters-popup pt-3">
        <div className="row">
          <div className="col-md-6">
            <div className="filter-group">
              <label>Product Barcode</label>
              <div className="barcode-input-container">
                <input
                  type="text"
                  name="barcode"
                  placeholder="Enter barcode"
                  className="form-controls"
                  value={barcode}
                  onChange={handleChange}
                />
                <button 
                  className="barcode-scan-btn"
                  onClick={handleScanBarcode}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="5" width="3" height="14" rx="1" stroke="#333" strokeWidth="2"/>
                    <rect x="8" y="5" width="2" height="14" rx="1" stroke="#333" strokeWidth="2"/>
                    <rect x="12" y="5" width="1" height="14" rx="0.5" stroke="#333" strokeWidth="1"/>
                    <rect x="15" y="5" width="1" height="14" rx="0.5" stroke="#333" strokeWidth="1"/>
                    <rect x="18" y="5" width="3" height="14" rx="1" stroke="#333" strokeWidth="2"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="filter-group">
              <label>SKU</label>
              <input
                type="text"
                name="sku"
                placeholder="Enter SKU"
                className="form-controls"
                value={sku}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="filter-group">
              <label>Track Stock</label>
              <Select
                options={trackStockOptions}
                value={trackStockOptions.find(option => option.value === trackStock)}
                classNamePrefix="my-select"
                onChange={handleTrackStockChange}
                styles={customStyles}
                placeholder="Choose Yes/No"
                isSearchable={false}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="filter-group">
              <label>Sell Online</label>
              <Select
                options={sellOnlineOptions}
                value={sellOnlineOptions.find(option => option.value === sellOnline)}
                classNamePrefix="my-select"
                onChange={handleSellOnlineChange}
                styles={customStyles}
                placeholder="Choose Yes/No"
                isSearchable={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="h_n _new__product">
      <div className="body_container cm_bg_white _nowhite __add_product">
        <TopHeader
          title="New Product"
          headerButtonStatus={true}
          cancelButton={true}
          {...props}
          onSave={handleSave}
        />
        <div className="new-setting-wrapper">
          <div className="container">
            {isLoading ? (
              <div className="text-center mt-5">
                <p>Loading categories and brands...</p>
              </div>
            ) : (
              <>
                {width < 1101 ?
                  <>
                    <Tabs
                      activeKey={activeTab}
                      onSelect={(k) => setActiveTab(k)}
                      id="product-tabs"
                      className="add_edit_service mb-3"
                    >
                      <Tab eventKey="details" title="Details" className="add_edit_service_content">
                        {renderProductDetails()}
                      </Tab>
                      <Tab eventKey="images" title="Images" className="add_edit_service_content">
                        {renderProductImages()}
                      </Tab>
                      <Tab eventKey="pricing" title="Pricing" className="add_edit_service_content">
                        {renderPricing()}
                      </Tab>
                      <Tab eventKey="stock" title="Stock" className="add_edit_service_content">
                        {renderStock()}
                      </Tab>
                    </Tabs>
                    <CancelSaveBtn onSave={handleSave} />
                  </>
                  : (
                    <>
                      <div className="detail-section">
                        {renderProductDetails()}
                        {renderProductImages()}
                      </div>
                      <div className="pricing-section">
                        {renderPricing()}
                        {renderStock()}
                      </div>
                    </>
                  )
                }
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(AddProduct);
